import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, PanelColorSettings, withColors, getColorClassName, CheckboxControl } = window.wp.blockEditor;
    
    const { 
        InnerBlocks,
    } = window.wp.editor;

    registerBlockType('custom-gutenberg/container', {
        // built-in attributes
        title: 'Container',
        description: 'Custom Container',
        icon: '',
        category: 'custom-containers',
        example: {},

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                classes
            } = attributes;

            return (
                <div class={ "container " }>
                    <InnerBlocks />
                </div>
            );
        },

        save({ attributes }) {

            const {
                classes
            } = attributes;

            return (
                <div className="container">
                    <InnerBlocks.Content />
                </div>
            );
        },
    });
}